import { useState } from "react";

const useLocalStorage = (key, default_value) => {
  const [localStorageValue, setLocalStorageValue] = useState(() => {
    try {
      if (!key) {
        return null;
      }
      const value = localStorage.getItem(key);
      if (value) {
        return JSON.parse(value);
      } else {
        localStorage.setItem(key, JSON.stringify(default_value));
        return default_value;
      }
    } catch (error) {
      localStorage.setItem(key, JSON.stringify(default_value));
      return default_value;
    }
  });

  const setLocalStorageStateValue = (valueOrFn) => {
    if (!key) {
      return;
    }
    let newValue;
    if (typeof valueOrFn === "function") {
      const fn = valueOrFn;
      newValue = fn(localStorageValue);
    } else {
      newValue = valueOrFn;
    }
    localStorage.setItem(key, JSON.stringify(newValue));
    setLocalStorageValue(newValue);
  };

  return [localStorageValue, setLocalStorageStateValue];
};

export default useLocalStorage;
